/**
 * Constants
 */

export const COLLECTION_NAME = {
  USERS: 'users', // root collection
  CUSTOMERS: 'customers', // root collection
  CHUMON: 'chumonFile',
  SHIYOULOT: 'shiyoulotFile',
  HIBETSUFILE: 'hibetsuFile',
  KEISHAHIBETSUFILE: 'keishaHibetsuFile',
  FARMMASTER: 'farmMaster',
  KEISHAMASTER: 'keishaMaster',
  KEISHUMASTER: 'keishuMaster',
  SHUKKASAKIMASTER: 'shukkaSakiMaster',
  TENTOUMASTER: 'tentouMaster',
  VACCINEMASTER: 'vaccineMaster',
  VACCINEPROGRAMMASTER: 'vaccineProgramMaster',
  SAIZAISAIKETSUNICHIREIMASTER: 'saizaiSaiketsuNichireiMaster',
  FEEDMASTER: 'feedMaster',
  SHIBOUKEIREPORTMASTER: 'shiboukeiReportMaster',
  MOKUHYOUTEMPERATUREMASTER: 'mokuhyouTemperatureMaster',
  ALERT: 'alerts',
  EVENT: 'eventFile',
  LAYOUT: 'layoutFile',
  CHOUHYOU: 'chouhyouFile',
  KEISHACONFIG: 'keishaConfig',
  MASTERS: 'masters'
} as const;

export const DOCUMENT_NAME = {
  KEISHACONFIGDOC: 'keishaConfigDoc',
  SHIYOULOT_NUMBER: 'shiyoulotNumber',
  CHUMON_NUMBER: 'chumonNumber',
} as const;

export const KEISHA_HIBETSU_FILE_GAIKION = genPropertyNameWithPreWord(['high', 'low'], 'TemperatureOutSide');

/**
 *
 * @param preWord
 * @param param
 */
function genPropertyNameWithPreWord(preWord: string[], param: string) {
  const propertyNames: string[] = [];
  preWord.forEach(val => {
    propertyNames.push(val + param);
  });
  return propertyNames;
}

//#region イベント関連

export const NYUUKA = 'nyuuka' as const;
export const SHUKKA = 'shukka' as const;
export const VACCINE = 'vaccine' as const;
export const SAIZAI = 'saizai' as const;
export const SAIKETSU = 'saiketsu' as const;
export const TAISOKU = 'taisoku' as const;
export const DEBEAK = 'debeak' as const;
export const OTHER = 'other' as const;

export const NYUUKA_KANA = '入荷' as const;
export const SHUKKA_KANA = '出荷' as const;
export const VACCINE_KANA = 'ワクチン' as const;
export const SAIZAI_KANA = '採材' as const;
export const SAIKETSU_KANA = '採血' as const;
export const TAISOKU_KANA = '体測' as const;
export const DEBEAK_KANA = 'デビーク' as const;
export const OTHER_KANA = 'その他' as const;

export const EVENT_SHUBETSU_LIST = [
  {eventShubetsu: NYUUKA, eventShubetsuName: NYUUKA_KANA},
  {eventShubetsu: SHUKKA, eventShubetsuName: SHUKKA_KANA},
  {eventShubetsu: VACCINE, eventShubetsuName: VACCINE_KANA},
  {eventShubetsu: SAIZAI, eventShubetsuName: SAIZAI_KANA},
  {eventShubetsu: SAIKETSU, eventShubetsuName: SAIKETSU_KANA},
  {eventShubetsu: TAISOKU, eventShubetsuName: TAISOKU_KANA},
  {eventShubetsu: DEBEAK, eventShubetsuName: DEBEAK_KANA},
  {eventShubetsu: OTHER, eventShubetsuName: OTHER_KANA},
] as const;

export const EVENT_SHUBETSU_EXCEPT_OTHER_OBJECT = {
  nyuuka: {eventShubetsu: NYUUKA, eventShubetsuName: NYUUKA_KANA},
  shukka: {eventShubetsu: SHUKKA, eventShubetsuName: SHUKKA_KANA},
  vaccine: {eventShubetsu: VACCINE, eventShubetsuName: VACCINE_KANA},
  saizai: {eventShubetsu: SAIZAI, eventShubetsuName: SAIZAI_KANA},
  saiketsu: {eventShubetsu: SAIKETSU, eventShubetsuName: SAIKETSU_KANA},
  taisoku: {eventShubetsu: TAISOKU, eventShubetsuName: TAISOKU_KANA},
  debeak: {eventShubetsu: DEBEAK, eventShubetsuName: DEBEAK_KANA},
} as const;

export const TO_DELETE = 'toDelete' as const;
export const HOVER = 'hover' as const;

export const VACCINE_KABU = 'vaccineKabu';
export const TOUYO_HOUHOU = 'touyoHouhou';
// 入荷・出荷関連は別途undoする処理があるのでコメントアウト
export const EVENT_JISSHI_PROPERTIES = [
  /*全イベント*/ 'jisshiDate', 'jisshiNichirei', 'jisshiSha', 'checked',
  /*入荷関連*/ //'nyuukaWasuu',
  /*出荷関連*/ //'shukkaWasuu', 'shukkaSakiShiyoulot',
  /*ワクチン関連*/ 'vaccineLotNumber', 'yuukouKigen',
  'youkaiEki', 'dansuiHour', 'sesshuBui',
  'isHattou', 'youkaiGoJikan', 'isWashedNyuukon',
  'changeNeedleFrequency', 'isWashedPister',
  /*体測関連*/ 'weights', 'cv', 'mean',
];

// ALL_OUTの場合は、出荷時に特殊処理を行う
export const SHUKKA_EVENT_NAME = {
  ALL_OUT: 'オールアウト'
} as const

export const GRAPH_LABEL_GRAM_PER_WA =  '[ g / 羽 ]';
export const GRAPH_LABEL_ML_PER_WA =  '[ ml / 羽 ]';
export const GRAPH_LABEL_DEGREE =  '[ ℃ ]';
export const GRAPH_LABEL_WA =  '[ 羽 ]';

// export const VACCINE_TEMPLATE = [
//   {yoteiDate: new Date(), yoteiNichirei: 0, vaccineName: 'MD', vaccineKabu: 'CVI', maker: '共立', touyoHouhou: '皮下'},
//   {yoteiDate: new Date(), yoteiNichirei: 0, vaccineName: 'MD', vaccineKabu: 'HVT', maker: 'ワクチノーバ', touyoHouhou: '皮下'},
//   {yoteiDate: new Date(), yoteiNichirei: 0, vaccineName: 'POX', vaccineKabu: '#946', maker: 'ワクチノーバ', touyoHouhou: '皮下'},
//   {yoteiDate: new Date(), yoteiNichirei: 0, vaccineName: 'IB', vaccineKabu: 'C-78', maker: '日生研', touyoHouhou: '散霧', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 14, vaccineName: 'NB', vaccineKabu: 'B1+L2', maker: 'ワクチノーバ', touyoHouhou: '飲水', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 21, vaccineName: 'IBD', vaccineKabu: 'ST-12•KS', maker: '共立', touyoHouhou: '飲水', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 28, vaccineName: 'IBD', vaccineKabu: 'K', maker: 'KMB', touyoHouhou: '飲水', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 35, vaccineName: 'IB', vaccineKabu: 'S-95-P7', maker: '日生研', touyoHouhou: '散霧', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 35, vaccineName: 'NB', vaccineKabu: 'MET95+TM-86', maker: 'KMB', touyoHouhou: '散霧', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 42, vaccineName: 'IB', vaccineKabu: 'AK01', maker: 'KMB', touyoHouhou: '散霧', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 60, vaccineName: 'NB', vaccineKabu: 'H-120', maker: '共立', touyoHouhou: '散霧', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 70, vaccineName: 'ILT(生)', vaccineKabu: 'CE', maker: 'KMB', touyoHouhou: '点眼', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 70, vaccineName: 'Mg(生)', vaccineKabu: 'K5831B-19', maker: 'ワクチノーバ', touyoHouhou: '点眼', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 70, vaccineName: 'POX', vaccineKabu: 'ボーデット', maker: '日生研', touyoHouhou: '穿刺', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 70, vaccineName: 'AE乾燥', vaccineKabu: '0596', maker: '日生研', touyoHouhou: '穿刺', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 85, vaccineName: 'IB', vaccineKabu: 'C-78', maker: '日生研', touyoHouhou: '散霧', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 95, vaccineName: '鶏5種混合オイルワクチン-C', vaccineKabu: '', maker: '京都微研', touyoHouhou: '左胸筋', dose: 1},
//   {yoteiDate: new Date(), yoteiNichirei: 95, vaccineName: 'EDS-76オイルワクチン-C', vaccineKabu: '', maker: '京都微研', touyoHouhou: '左胸筋', dose: 0.5},
//   {yoteiDate: new Date(), yoteiNichirei: 95, vaccineName: '鶏サルモネラ不活化3混•KS', vaccineKabu: '', maker: '共立', touyoHouhou: '左胸筋', dose: 1},];

export const VACCINE_PROGRAM_TEMPLATE = [
  {yoteiNichirei: 0, vaccineName: 'MD', vaccineKabu: 'CVI', maker: '共立', touyoHouhou: '皮下'},
  {yoteiNichirei: 0, vaccineName: 'MD', vaccineKabu: 'HVT', maker: 'ワクチノーバ', touyoHouhou: '皮下'},
  {yoteiNichirei: 0, vaccineName: 'POX', vaccineKabu: '#946', maker: 'ワクチノーバ', touyoHouhou: '皮下'},
  {yoteiNichirei: 0, vaccineName: 'IB', vaccineKabu: 'C-78', maker: '日生研', touyoHouhou: '散霧', dose: 1},
  {yoteiNichirei: 14, vaccineName: 'NB', vaccineKabu: 'B1+L2', maker: 'ワクチノーバ', touyoHouhou: '飲水', dose: 1},
  {yoteiNichirei: 21, vaccineName: 'IBD', vaccineKabu: 'ST-12•KS', maker: '共立', touyoHouhou: '飲水', dose: 1},
  {yoteiNichirei: 28, vaccineName: 'IBD', vaccineKabu: 'K', maker: 'KMB', touyoHouhou: '飲水', dose: 1},
  {yoteiNichirei: 35, vaccineName: 'IB', vaccineKabu: 'S-95-P7', maker: '日生研', touyoHouhou: '散霧', dose: 1},
  {yoteiNichirei: 35, vaccineName: 'NB', vaccineKabu: 'MET95+TM-86', maker: 'KMB', touyoHouhou: '散霧', dose: 1},
  {yoteiNichirei: 42, vaccineName: 'IB', vaccineKabu: 'AK01', maker: 'KMB', touyoHouhou: '散霧', dose: 1},
  {yoteiNichirei: 60, vaccineName: 'NB', vaccineKabu: 'H-120', maker: '共立', touyoHouhou: '散霧', dose: 1},
  {yoteiNichirei: 70, vaccineName: 'ILT(生)', vaccineKabu: 'CE', maker: 'KMB', touyoHouhou: '点眼', dose: 1},
  {yoteiNichirei: 70, vaccineName: 'Mg(生)', vaccineKabu: 'K5831B-19', maker: 'ワクチノーバ', touyoHouhou: '点眼', dose: 1},
  {yoteiNichirei: 70, vaccineName: 'POX', vaccineKabu: 'ボーデット', maker: '日生研', touyoHouhou: '穿刺', dose: 1},
  {yoteiNichirei: 70, vaccineName: 'AE乾燥', vaccineKabu: '0596', maker: '日生研', touyoHouhou: '穿刺', dose: 1},
  {yoteiNichirei: 85, vaccineName: 'IB', vaccineKabu: 'C-78', maker: '日生研', touyoHouhou: '散霧', dose: 1},
  {yoteiNichirei: 95, vaccineName: '鶏5種混合オイルワクチン-C', vaccineKabu: '', maker: '京都微研', touyoHouhou: '左胸筋', dose: 1},
  {yoteiNichirei: 95, vaccineName: 'EDS-76オイルワクチン-C', vaccineKabu: '', maker: '京都微研', touyoHouhou: '左胸筋', dose: 0.5},
  {yoteiNichirei: 95, vaccineName: '鶏サルモネラ不活化3混•KS', vaccineKabu: '', maker: '共立', touyoHouhou: '左胸筋', dose: 1}, ];

export const VACCINE_TEMPLATE = [
  {vaccineName: 'MD', vaccineKabu: 'CVI', maker: '共立製薬', },
  {vaccineName: 'MD', vaccineKabu: 'HVT', maker: 'ワクチノーバ', },
  {vaccineName: 'POX', vaccineKabu: '#946', maker: 'ワクチノーバ', },
  {vaccineName: 'POX', vaccineKabu: 'ボーデット', maker: '日生研', },
  {vaccineName: 'POX', vaccineKabu: 'FP', maker: '日生研', },
  {vaccineName: 'POX', vaccineKabu: 'ポキシン', maker: 'ワクチノーバ', },
  {vaccineName: 'IB', vaccineKabu: 'C-78', maker: '共立製薬', },
  {vaccineName: 'IB', vaccineKabu: 'S-95-P7', maker: '日生研', },
  {vaccineName: 'IB', vaccineKabu: 'AK01', maker: 'KMB', },
  {vaccineName: 'IB', vaccineKabu: 'TM-86', maker: 'KMB', },
  {vaccineName: 'IB', vaccineKabu: 'H-120', maker: '全薬', },
  {vaccineName: 'IB', vaccineKabu: 'H-120', maker: 'BIAHJ', },
  {vaccineName: 'IB', vaccineKabu: '宮崎', maker: '日生研', },
  {vaccineName: 'ND', vaccineKabu: 'B1', maker: '日生研', },
  {vaccineName: 'ND', vaccineKabu: 'VG/GA', maker: 'BIAHJ', },
  {vaccineName: 'NB', vaccineKabu: 'B1＋L2', maker: 'KMB', },
  {vaccineName: 'NB', vaccineKabu: 'MET95＋TM-86', maker: 'KMB', },
  {vaccineName: 'NB', vaccineKabu: 'B1＋H-120', maker: '共立製薬', },
  {vaccineName: 'NB', vaccineKabu: 'B1＋ON', maker: '日生研', },
  {vaccineName: 'NB', vaccineKabu: 'B1＋北一', maker: '科飼研', },
  {vaccineName: 'NB', vaccineKabu: 'B1＋練馬', maker: 'KMB', },
  {vaccineName: 'NB', vaccineKabu: 'CLONE30＋MA5', maker: 'MSD', },
  {vaccineName: 'IBD', vaccineKabu: 'ST-12・KS', maker: '共立製薬', },
  {vaccineName: 'IBD', vaccineKabu: 'K', maker: 'KMB', },
  {vaccineName: 'IBD', vaccineKabu: 'MB-1・E', maker: '日生研', },
  {vaccineName: 'IBD', vaccineKabu: 'D-78', maker: 'MSD', },
  {vaccineName: 'IBD', vaccineKabu: 'Taishu', maker: '京都微研', },
  {vaccineName: 'IBD', vaccineKabu: 'ルカート-BP', maker: 'ワクチノーバ', },
  {vaccineName: 'IBD', vaccineKabu: 'IBD生"化血研"L', maker: 'KMB', },
  {vaccineName: 'ILT（生）', vaccineKabu: 'CE', maker: 'KMB', },
  {vaccineName: 'ILT（生）', vaccineKabu: 'エルティバックス', maker: '共立製薬', },
  {vaccineName: 'AE乾燥', vaccineKabu: '0596', maker: '日生研', },
  {vaccineName: 'AE（生）', vaccineKabu: '#1010', maker: 'ワクチノーバ', },
  {vaccineName: '鶏５種混合オイルワクチン-C', vaccineKabu: '', maker: '京都微研', },
  {vaccineName: 'EDS不活化オイルワクチン', vaccineKabu: '', maker: '日生研', },
  {vaccineName: '鶏サルモネラ不活化３混・KS', vaccineKabu: '', maker: '共立製薬', },
  {vaccineName: 'オイルバックス7R', vaccineKabu: '', maker: 'KMB', },
  {vaccineName: 'オイルバックスSETi', vaccineKabu: '', maker: 'KMB', },
  {vaccineName: 'オイルバックスReo', vaccineKabu: '58-132E50', maker: 'KMB', },
  {vaccineName: 'Mg（生）', vaccineKabu: 'K5831B-19', maker: 'ワクチノーバ', },
  {vaccineName: 'CAV', vaccineKabu: 'P-4', maker: 'MSD', },
  {vaccineName: 'AE＋POX', vaccineKabu: '#1143＋HUDSON', maker: 'ワクチノーバ', },
  {vaccineName: 'NB2G', vaccineKabu: '', maker: 'KMB', },
  {vaccineName: 'MS', vaccineKabu: 'MS-H', maker: '全薬', },
  {vaccineName: '大腸菌', vaccineKabu: '078 AESN1331', maker: '日生研', }
];

export const SHUBETSU = 'shubetsu';
export const SAIZAI_TEMPLATE = [
  {yoteiNichirei: 30, [SHUBETSU]: 'サルモネラ'},
  {yoteiNichirei: 100, [SHUBETSU]: 'サルモネラ'},
];

export const SAIKETSU_TEMPLATE = [
  {yoteiNichirei: 55},
  {yoteiNichirei: 115},
];

export const MISETTEI_KANA = '未設定';
export const TOUYO_HOUHOUS = [
  {value: 'spray', name: 'スプレー'},
  {value: 'insui', name: '飲水'},
  {value: 'tengan', name: '点眼'},
  {value: 'sanmu', name: '散霧'},
  {value: 'kinchuu', name: '筋注'},
  {value: 'hikachuu', name: '皮下注'},
  {value: 'senshi', name: '穿刺'},
  {value: 'misettei', name: MISETTEI_KANA},
] as const;

export const MARU_BATSU = [
  {value: true, name: '○'},
  {value: false, name: '×'},
];

//#endregion

export const FEED_TEMPLATE = [
  {id: '', feedShubetsu: '餌付用', cp: 23, ME: 3010},
  {id: '', feedShubetsu: '幼雛用', cp: 20, ME: 2950},
  {id: '', feedShubetsu: '中雛用', cp: 17, ME: 2850},
  {id: '', feedShubetsu: '大雛用', cp: 15, ME: 2800},
  {id: '', feedShubetsu: '成鶏用', cp: 15, ME: 2700},
];

export const TENTOU_TEMPLATE = [
  {startNichirei: 1, endNichirei: 7, tentouShoutouJikoku: [{start: '02:00', end: '00:00'}], toDelete: false},
  {startNichirei: 8, endNichirei: 14, tentouShoutouJikoku: [{start: '02:00', end: '22:00'}], toDelete: false},
  {startNichirei: 15, endNichirei: 21, tentouShoutouJikoku: [{start: '03:00', end: '21:00'}], toDelete: false},
  {startNichirei: 22, endNichirei: 28, tentouShoutouJikoku: [{start: '04:00', end: '20:00'}], toDelete: false},
  {startNichirei: 29, endNichirei: 35, tentouShoutouJikoku: [{start: '05:00', end: '19:00'}], toDelete: false},
  {startNichirei: 36, endNichirei: 42, tentouShoutouJikoku: [{start: '05:30', end: '18:30'}], toDelete: false},
  {startNichirei: 43, endNichirei: 49, tentouShoutouJikoku: [{start: '06:30', end: '17:30'}], toDelete: false},
];

export const LOW_TEMPERATURE = 'lowTemperature';
export const CURRENT_TEMPERATURE = 'currentTemperature';
export const HIGH_TEMPERATURE = 'highTemperature';
export const HEISHI = 'heishi';
export const HEISHI_KAGEN = 'heishiKagen';
export const ESA = 'esa';
export const MIZU = 'mizu';
export const TAISOKU_CV = 'taisokuCV';
export const TAISOKU_MHI = 'taisokuMhi';

export const ALERT_TEMPLATE = [
  // {shubetsu: LOW_TEMPERATURE, item: '鶏舎内温度', subItem: '低温', shikiiChi: 10, bikou: '°C より低い場合', isValid: true},
  // {shubetsu: HIGH_TEMPERATURE, item: '鶏舎内温度', subItem: '高温', shikiiChi: 30, bikou: '°C より高い場合', isValid: true},
  {shubetsu: HEISHI, item: '斃死', subItem: '前日比', shikiiChi: 2, bikou: '倍 以上の場合', isValid: true},
  {shubetsu: HEISHI_KAGEN, item: '斃死', subItem: '下限', shikiiChi: 10, bikou: '羽 以上の場合', isValid: true},
  // {shubetsu: 'touta',item: '淘汰', subItem: '前日比', shikiiChi: 2, bikou: '倍 以上の場合', isValid: true},
  {shubetsu: ESA, item: '給餌量', subItem: '前日比', shikiiChi: 10, bikou: '％ 以上の場合', isValid: true},
  {shubetsu: MIZU, item: '給水量', subItem: '前日比', shikiiChi: 15, bikou: '％ 以上の場合', isValid: true},
  {shubetsu: TAISOKU_CV, item: '体重', subItem: 'CV', shikiiChi: 8, bikou: '％ 以上の場合', isValid: true},
  {shubetsu: TAISOKU_MHI, item: '体重', subItem: 'マニュアル比', shikiiChi: 10, bikou: '％ 以上の場合', isValid: true},
];

export const LAYOUT_TEMPLATE = {
  row: 42,
  column: 4,
  stage: 3,
  floor: 2,
};

// export const TAISOKU_CSV_FORMAT = [
//   {propertyName: 'index', columnIndex: 0},
//   {propertyName: 'dateStr', columnIndex: 1},
//   {propertyName: 'timeStr', columnIndex: 2},
//   {propertyName: 'ST', columnIndex: 3},
//   {propertyName: 'weight', columnIndex: 4},
//   {propertyName: 'unit', columnIndex: 5},
// ]

export const TAISOKU_CSV_FORMAT
  = {
    index: 0,
    dateStr: 1,
    timeStr: 2,
    ST: 3,
    weight:4,
    unit:5
  };

export const QUERY_LIMIT_SHIYOULOT = 51; // 表示する件数 + 1 TODO 件数仮決め
export const QUERY_LIMIT_ALERT = 51; // 表示する件数 + 1
export const QUERY_LIMIT_CHUMON = 51; // 表示する件数 + 1 TODO 件数仮決め

export const SHIYOULOTHIBETSUFILE_EDITABLE_LIMIT = -90; // 90日前まで編集可能
export const NYUUKA_SHUKKA_EDITABLE_LIMIT = 90; // 90日前まで編集可能
export const EVENT_SHUTOKU_DATERANGE_LIMIT = 90; // 90日間のみ取得可能
export const SHIYOULOT_VERSION = 2; //2022/8/29 全ロットver: 2 で更新。

export const KG_TO_G = 1000; // 1kg → 1000g に変換

// 完全出荷時、未実施イベントの実施日にセットする時などで使用
export const DEFAULT_JISSHIDATE = '9999-12-31';

// 入出荷イベントの冪等化ガードエラー
// event.service の入出荷トランザクションが reject する理由文字列。
// updateNyuushukkaEvent2 がこの値と一致した場合のみ具体的なメッセージを表示する。
export const EVENT_GUARD_ERROR = {
  ALREADY_REGISTERED: 'この作業は既に登録済みです。',
  NOT_REGISTERED: 'この作業は未実施のため取り消しできません。',
  EVENT_NOT_FOUND: 'イベントが見つかりません。',
  NO_GENZAI_WASUU: '現在羽数が0のため出荷できません。',
  INVALID_NYUUKA_WASUU: '入荷羽数は1以上の整数で入力してください。',
  INVALID_SHUKKA_WASUU: '出荷羽数は1以上の整数で入力してください。',
};

export const WEEK = [
  {value: 'sunday', name: '日曜日'},
  {value: 'monday', name: '月曜日'},
  {value: 'tuesday', name: '火曜日'},
  {value: 'wednesday', name: '水曜日'},
  {value: 'thursday', name: '木曜日'},
  {value: 'friday', name: '金曜日'},
  {value: 'saturday', name: '土曜日'},
];

//#region 羽数関連

export const OSU_WASUU = 'osuWasuu';
export const ASHI_WASUU = 'ashiWasuu';
export const KUCHI_WASUU = 'kuchiWasuu';
export const KIKEI_WASUU = 'kikeiWasuu';
export const SHOU_WASUU = 'shouWasuu';
export const OTHER_WASUU = 'otherWasuu';
export const HEISHI_WASUU = 'heishiWasuu';
export const TOUTA_WASUU = 'toutaWasuu';
export const TEISEI_WASUU = 'teiseiWasuu';
export const GENZAI_WASUU = 'genzaiWasuu';
export const NYUUKA_WASUU = 'nyuukaWasuu';
export const SHUKKA_WASUU = 'shukkaWasuu';

export const HEISHI_WASUU_KANA = '斃死羽数';
export const TOUTA_WASUU_KANA = '淘汰羽数';
export const TEISEI_WASUU_KANA = '訂正羽数';
export const GENZAI_WASUU_KANA = '現在羽数';
export const SHUKKA_WASUU_KANA = '出荷羽数';

export const OSU_WASUU_KANA = '♂混ざり・誤鑑';
export const ASHI_WASUU_KANA = '脚弱・脚折れ';
export const KUCHI_WASUU_KANA = '口曲がり';
export const KIKEI_WASUU_KANA = '奇形';
export const SHOU_WASUU_KANA = '未熟・小さい個体';
export const OTHER_WASUU_KANA = 'その他淘汰';
export const HEISHI_KANA = '斃死';
//#endregion

export const HEISHI_TOUTA_PROPERTIES = {
  [OSU_WASUU]: OSU_WASUU_KANA, [ASHI_WASUU]: ASHI_WASUU_KANA, [KUCHI_WASUU]: KUCHI_WASUU_KANA,
  [KIKEI_WASUU]: KIKEI_WASUU_KANA, [SHOU_WASUU]: SHOU_WASUU_KANA, [OTHER_WASUU]: OTHER_WASUU_KANA, [HEISHI_WASUU]: HEISHI_KANA
} as const;

export const HEISHI_TOUTA_TEISEI_PROPERTIES = {
  [OSU_WASUU]: OSU_WASUU_KANA,
  [ASHI_WASUU]: ASHI_WASUU_KANA,
  [KUCHI_WASUU]: KUCHI_WASUU_KANA,
  [KIKEI_WASUU]: KIKEI_WASUU_KANA,
  [SHOU_WASUU]: SHOU_WASUU_KANA,
  [OTHER_WASUU]: OTHER_WASUU_KANA,
  [HEISHI_WASUU]: HEISHI_KANA,
  [TEISEI_WASUU]: TEISEI_WASUU_KANA
};

export const GRAPH_SHUBETSU_FOR_SHIYOULOT = [
  {shubetsu: 'taisoku', name: '体重推移'},
  {shubetsu: 'ikuseiRitsu', name: '育成率(%)'},
  {shubetsu: 'wasuu', name: '羽数'},
];

export const GRAPH_SHUBETSU_FOR_KEISHA = [
  {shubetsu: 'kion', name: '気温推移'},
  {shubetsu: 'kyuujiRyou', name: '給餌量'},
  {shubetsu: 'kyuusuiRyou', name: '給水量'},
];

export const CHART_TYPE = {
  temperature: 'Temperature',
  wasuu: 'Wasuu',
  kyuujiRyou: 'KyuujiRyou',
  kyuusuiRyou: 'KyuusuiRyou',
  others: 'Others'
};

// export const COLOR = [
//   'olive', 'fuchsia','aqua','maroon', 'red',
//   'gray','blue','green','purple','teal', 'lime',
// ]

export const COLOR_SHUBETSU = {
  CONTEXT: 'rgba(255,0,0,0.5)',
  TAISOKU: 'sandybrown',
  FIRST_CELL: '#ffffe0',
  VACANT: 'rgb(251, 248, 233)',
};

export const IKUSUU = 'ikusuu' as const;
export const IKUSEI = 'ikusei' as const;

export const FARM_SHUBETSU = {
  IKUSUU: 'ikusuu',
  IKUSEI: 'ikusei',
};

export const KEISHA_SHUBETSU = {
  IKUSUU: 'ikusuu',
  IKUSEI: 'ikusei',
};

export const SHUBETSU_LIST = [
  {nameKana: '育雛', name: IKUSUU},
  {nameKana: '育成', name: IKUSEI},
];

export const SEIJOU = 'seijou';
export const NAKI = 'naki';
export const KETSUBAN = 'ketsuben';
export const CHINUTSU = 'chinutsu';
export const SONOTA = 'sonota';
export const MIHOUKOKU = 'miHoukoku';
export const HOUKOKUZUMI = 'houkokuZumi';

//# region AM/PM
export const AM = 'AM';
export const PM = 'PM';
export const AM_KANA = '午前';
export const PM_KANA = '午後';
export const IS_PM = 'isPM';
//# endregion

export const ABNORMAL_PROPERTIES = {
  [SEIJOU]: '正常',
  [NAKI]: '鳴き',
  [KETSUBAN]: '血便',
  [CHINUTSU]: '沈鬱',
  [SONOTA]: 'その他'
} as const;

export const TAIOU_PROPERTIES = {
  [MIHOUKOKU]: 'これから報告',
  [HOUKOKUZUMI]: '報告済み'
};

export const KEISHAHIBETSUFILE_PROPERTY = {
  PREFIX: {
    SUIDOU_METER: 'suidouMeter',
    LATEST_SUIDOU_METER: 'latestSuidouMeter',
    ESA_ZAN: 'esaZan',
  } as const,
  INTERFIX: {
    TEMPERATURE: 'Temperature',
  } as const,
  TEMPERATURE: 'temperature',
  ESA_ZAN: 'esaZan',
  FEED: 'feed',
  SUIDOU_METER: 'suidouMeter',
  TODAY_SHIYOULOT_HEISHI_TOUTA: 'todayShiyoulotHeishiTouta',
  TENTOU_SHOUTOU_JIKOKU: 'tentouShoutouJikoku',
  WARIKOMI_TENTOU_SHOUTOU_JIKOKU: 'warikomiTentouShoutouJikoku',
} as const;

export const METER_SHUBETSU = {am: 'suidouMeterAM', pm: 'suidouMeterPM', latest: 'latestSuidouMeter'} as const;

// 水道メーター関連は階数が不定のため、これによらず別途処理する必要有
export const DEFAULT_KEISHA_HIBETSUFILE = {
  // id: this.commonService.getDateWithString(),
  // keishaId: keishaId,
  seijou: false, naki:false, ketsuben:false, chinutsu:false, sonota:false, taiouZumi:false, houkokuZumi:false,
  hansouRyou: 0, hansouMeter: '00:00:00'};

export const SHIYOULOT_KEY_SUFFIX = '-S';
// 「123-S」みたいな形式の文字列
export const REGEX_SHIYOULOT_KEY = new RegExp('\\d+' + SHIYOULOT_KEY_SUFFIX);
// 手動で追加した「注文」DocのIdのプレフィックス
export const MANUAL_CHUMON_PREFIX = 'M';

export const DEFAULT_SHIYOULOT_HIBETSUFILE = {
  // id: this.commonService.getDateWithString(),
  // shiyoulotNumber: shiyoulot.id,
  // keishaId: keishaId,
  [OSU_WASUU]: 0, [ASHI_WASUU]: 0, [KUCHI_WASUU]: 0,
  [KIKEI_WASUU]: 0, [SHOU_WASUU]: 0, [OTHER_WASUU]: 0, [HEISHI_WASUU]: 0};

// 取得したい style プロパティ配列
export const NO_DATA_CLASS_PROPATIES = [
  'height', 'font-size', 'border', 'text-align'
];

// 客先提出帳票(kyakusaki-teishutsu-chouhyou-seisei-old.component.ts)での餌情報取得テスト用
export const KEISHAHIBETSU_FOR_KYAKUSAKITEISHUTSU = [
  {id: '2019-01-01', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-02', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-03', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-04', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-05', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-06', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-07', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-08', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-09', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-10', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-11', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-12', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-13', feed: {id: '17d7463c79ec9', feedShubetsu: '餌付用', ME:3010, cp: 23}},
  {id: '2019-01-14', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-15', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-16', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-17', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-18', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-19', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-20', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-21', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-22', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-23', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-24', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-25', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-26', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-27', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-28', feed: {id: '17d7463c79e257', feedShubetsu: '幼雛用', ME:2950, cp: 24}},
  {id: '2019-01-29', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-01-30', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-01-31', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-01', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-02', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-03', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-04', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-05', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-06', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-07', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-08', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-09', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-10', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-11', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-12', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-13', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-14', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-15', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-16', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-17', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-18', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-19', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-20', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-21', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-22', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-23', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-24', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-25', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-26', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-27', feed: {id: '17d7463c79e2c4', feedShubetsu: '中雛用', ME:2850, cp: 17}},
  {id: '2019-02-28', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-01', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-02', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-03', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-04', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-05', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-06', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-07', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-08', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-09', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-10', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-11', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-12', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-13', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-14', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-15', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-16', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-17', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-18', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-19', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-20', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-21', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-22', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-23', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-24', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-25', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-26', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-27', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-28', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-29', feed: {id: '17d7463c79e279', feedShubetsu: '大雛用', ME:2800, cp: 15}},
  {id: '2019-03-30', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-03-31', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-01', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-02', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-03', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-04', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-05', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-06', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-07', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-08', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-09', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-10', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-11', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-12', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-13', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-14', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-15', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-16', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-17', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}},
  {id: '2019-04-18', feed: {id: '17d7463c79e3d1', feedShubetsu: '成鶏用', ME:2700, cp: 15}}
];

export const KEISHAHIBETSU_TENTOU_TEST = [
  {id: '2019-01-01', tentouShoutouJikoku: [{start:'02:00', end: '00:00'}]},
  {id: '2019-01-02', tentouShoutouJikoku: [{start:'02:00', end: '00:00'}]},
  {id: '2019-01-03', tentouShoutouJikoku: [{start:'02:00', end: '00:00'}]},
  {id: '2019-01-04', tentouShoutouJikoku: [{start:'02:00', end: '00:00'}]},
  {id: '2019-01-05', tentouShoutouJikoku: [{start:'02:00', end: '00:00'}]},
  {id: '2019-01-06', tentouShoutouJikoku: [{start:'02:00', end: '00:00'}]},
  {id: '2019-01-07', tentouShoutouJikoku: [{start:'02:00', end: '00:00'}]},
  {id: '2019-01-08', tentouShoutouJikoku: [{start:'02:00', end: '22:00'}]},
  {id: '2019-01-09', tentouShoutouJikoku: [{start:'02:00', end: '22:00'}]},
  {id: '2019-01-10', tentouShoutouJikoku: [{start:'02:00', end: '22:00'}]},
  {id: '2019-01-11', tentouShoutouJikoku: [{start:'02:00', end: '22:00'}]},
  {id: '2019-01-12', tentouShoutouJikoku: [{start:'02:00', end: '22:00'}]},
  {id: '2019-01-13', tentouShoutouJikoku: [{start:'02:00', end: '22:00'}]},
  {id: '2019-01-14', tentouShoutouJikoku: [{start:'02:00', end: '22:00'}]},
  {id: '2019-01-15', tentouShoutouJikoku: [{start:'03:00', end: '21:00'}]},
  {id: '2019-01-16', tentouShoutouJikoku: [{start:'03:00', end: '21:00'}]},
  {id: '2019-01-17', tentouShoutouJikoku: [{start:'03:00', end: '21:00'}]},
  {id: '2019-01-18', tentouShoutouJikoku: [{start:'03:00', end: '21:00'}]},
  {id: '2019-01-19', tentouShoutouJikoku: [{start:'03:00', end: '21:00'}]},
  {id: '2019-01-20', tentouShoutouJikoku: [{start:'03:00', end: '21:00'}]},
  {id: '2019-01-21', tentouShoutouJikoku: [{start:'03:00', end: '21:00'}]},
  {id: '2019-01-22', tentouShoutouJikoku: [{start:'04:00', end: '20:00'}]},
  {id: '2019-01-23', tentouShoutouJikoku: [{start:'04:00', end: '20:00'}]},
  {id: '2019-01-24', tentouShoutouJikoku: [{start:'04:00', end: '20:00'}]},
  {id: '2019-01-25', tentouShoutouJikoku: [{start:'04:00', end: '20:00'}]},
  {id: '2019-01-26', tentouShoutouJikoku: [{start:'04:00', end: '20:00'}]},
  {id: '2019-01-27', tentouShoutouJikoku: [{start:'04:00', end: '20:00'}]},
  {id: '2019-01-28', tentouShoutouJikoku: [{start:'04:00', end: '20:00'}]},
  {id: '2019-01-29', tentouShoutouJikoku: [{start:'05:00', end: '19:00'}]},
  {id: '2019-01-30', tentouShoutouJikoku: [{start:'05:00', end: '19:00'}]},
  {id: '2019-01-31', tentouShoutouJikoku: [{start:'05:00', end: '19:00'}]},
  {id: '2019-02-01', tentouShoutouJikoku: [{start:'05:00', end: '19:00'}]},
  {id: '2019-02-02', tentouShoutouJikoku: [{start:'05:00', end: '19:00'}]},
  {id: '2019-02-03', tentouShoutouJikoku: [{start:'05:00', end: '19:00'}]},
  {id: '2019-02-04', tentouShoutouJikoku: [{start:'05:00', end: '19:00'}]},
  {id: '2019-02-05', tentouShoutouJikoku: [{start:'05:30', end: '18:30'}]},
  {id: '2019-02-06', tentouShoutouJikoku: [{start:'05:30', end: '18:30'}]},
  {id: '2019-02-07', tentouShoutouJikoku: [{start:'05:30', end: '18:30'}]},
  {id: '2019-02-08', tentouShoutouJikoku: [{start:'05:30', end: '18:30'}]},
  {id: '2019-02-09', tentouShoutouJikoku: [{start:'05:30', end: '18:30'}]},
  {id: '2019-02-10', tentouShoutouJikoku: [{start:'05:30', end: '18:30'}]},
  {id: '2019-02-11', tentouShoutouJikoku: [{start:'05:30', end: '18:30'}]},
  {id: '2019-02-12', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-13', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-14', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-15', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-16', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-17', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-18', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-19', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-20', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-21', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-22', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-23', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-24', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-25', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-26', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-27', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-02-28', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-01', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-02', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-03', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-04', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-05', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-06', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-07', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-08', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-09', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-10', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-11', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-12', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-13', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-14', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-15', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-16', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-17', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-18', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-19', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-20', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-21', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-22', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-23', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-24', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-25', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-26', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-27', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-28', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-29', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-30', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-03-31', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-01', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-02', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-03', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-04', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-05', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-06', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-07', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-08', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-09', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-10', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-11', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-12', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-13', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-14', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-15', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-16', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-17', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
  {id: '2019-04-18', tentouShoutouJikoku: [{start:'06:30', end: '17:30'}]},
];
